import DatePicker from 'components/form/DatePicker';
import TextArea from 'components/form/TextArea';
import TextInput from 'components/form/TextInput';
import React from 'react';
// Coupon or Voucher follow ups/early bird deadline - Set 2
const ElevenStepOfFollowUps = ({ props, isEdit, suggestionData }) => {
  // const { handleChange, values } = props;
  const { values, errors, touched, handleChange, handleBlur } = props;

  const {
    client_name,
    conference_short_name,
    conference_location,
    conference_from_date,
    conference_to_date,
    coupon_code,
    discount_amount,
    registration_link,
    your_name,
    contact_details,
  } = values;
  return (
    <>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Recipient's Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="client_name"
            onChange={handleChange}
            value={client_name}
            disabled={!isEdit}
            onBlur={handleBlur}
            error={touched.client_name && errors.client_name}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Conference Short Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="conference_short_name"
            onChange={handleChange}
            value={conference_short_name}
            disabled={!isEdit}
            onBlur={handleBlur}
            error={touched.conference_short_name && errors.conference_short_name}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Conference From Date
        </div>
        <div className="col-lg-6">
          <DatePicker
            id="conference_from_date"
            onChange={handleChange}
            value={conference_from_date}
            disabled={!isEdit}
            error={errors.conference_from_date}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Conference To Date
        </div>
        <div className="col-lg-6">
          <DatePicker
            id="conference_to_date"
            onChange={handleChange}
            value={conference_to_date}
            disabled={!isEdit}
            error={errors.conference_to_date}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Conference Venue
        </div>
        <div className="col-lg-6">
          <TextInput
            id="conference_location"
            onChange={handleChange}
            value={conference_location}
            disabled={!isEdit}
            suggestions={suggestionData?.conference_location}
            onBlur={handleBlur}
            error={touched.conference_location && errors.conference_location}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Coupon Code
        </div>
        <div className="col-lg-6">
          <TextInput
            id="coupon_code"
            onChange={handleChange}
            value={coupon_code}
            disabled={!isEdit}
            suggestions={suggestionData?.coupon_code}
            onBlur={handleBlur}
            error={touched.coupon_code && errors.coupon_code}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Discount Amount
        </div>
        <div className="col-lg-6">
          <TextInput
            id="discount_amount"
            onChange={handleChange}
            value={discount_amount}
            disabled={!isEdit}
            suggestions={suggestionData?.discount_amount}
            onBlur={handleBlur}
            error={touched.discount_amount && errors.discount_amount}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Registration Link
        </div>
        <div className="col-lg-6">
          <TextInput
            id="registration_link"
            onChange={handleChange}
            value={registration_link}
            disabled={!isEdit}
            suggestions={suggestionData?.registration_link}
            onBlur={handleBlur}
            error={touched.registration_link && errors.registration_link}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Your Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="your_name"
            onChange={handleChange}
            value={your_name}
            disabled={!isEdit}
            suggestions={suggestionData?.your_name}
            onBlur={handleBlur}
            error={touched.your_name && errors.your_name}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Contact Details
        </div>
        <div className="col-lg-6">
          <TextInput
            id="contact_details"
            onChange={handleChange}
            value={contact_details}
            disabled={!isEdit}
            suggestions={suggestionData?.contact_details}
            onBlur={handleBlur}
            error={touched.contact_details && errors.contact_details}
          />
        </div>
      </div>
    </>
  );
};

export default ElevenStepOfFollowUps;
